class FeaturedCollection extends HTMLElement {
constructor() {
    super();
    this.featuredContainer = this;
    this.navlinks = this.querySelectorAll('.collection__nav-link')
    this.viewAllLinks = this.querySelectorAll('.collection__view-all-link')
    this.sliderComponent = this.querySelectorAll('.slider-component')

    this.navlinks.forEach((link) => {
    link.addEventListener('click', this.activateTab.bind(this))
    })
}

activateTab(event) {
    if (event.target.classList.contains('is-active')) {
    return
    }

    this.navlinks.forEach((link) => {
    link.classList.remove('is-active')
    })

    event.target.classList.add('is-active')
    this.activateCarousel(event.target.dataset.index)
    this.activateViewAll(event.target.dataset.index)
}

activateCarousel(activeIndex) {
    this.sliderComponent.forEach((item) => {
    if (item.dataset.index === activeIndex) {
        item.classList.add('is-active')

    } else {
        item.classList.remove('is-active')
    }
    })
}

activateViewAll(activeIndex) {
    if (this.viewAllLinks) {
    this.viewAllLinks.forEach((item) => {
        if (item.dataset.index === activeIndex) {
        item.classList.add('is-active')

        } else {
        item.classList.remove('is-active')
        }
    })
    }
}
}

customElements.define('featured-collection', FeaturedCollection);